import { NavLink } from "react-router-dom";
import { useState } from "react";

export default function Sidebar() {
  const [activeMenu, setActiveMenu] = useState(null);

  // أيقونات SVG
  const HomeIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
      <path d="M11.47 3.84a.75.75 0 011.06 0l8.69 8.69a.75.75 0 101.06-1.06l-8.689-8.69a2.25 2.25 0 00-3.182 0l-8.69 8.69a.75.75 0 001.061 1.06l8.69-8.69z" />
      <path d="M12 5.432l8.159 8.159c.03.03.06.058.091.086v6.198c0 1.035-.84 1.875-1.875 1.875H15a.75.75 0 01-.75-.75v-4.5a.75.75 0 00-.75-.75h-3a.75.75 0 00-.75.75V21a.75.75 0 01-.75.75H5.625a1.875 1.875 0 01-1.875-1.875v-6.198a2.29 2.29 0 00.091-.086L12 5.43z" />
    </svg>
  );

  const TrainerIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
      <path fillRule="evenodd" d="M8.25 6.75a3.75 3.75 0 117.5 0 3.75 3.75 0 01-7.5 0zM15.75 9.75a3 3 0 116 0 3 3 0 01-6 0zM2.25 9.75a3 3 0 116 0 3 3 0 01-6 0zM6.31 15.117A6.745 6.745 0 0112 12a6.745 6.745 0 016.709 7.498.75.75 0 01-.372.568A12.696 12.696 0 0112 21.75c-2.305 0-4.47-.612-6.337-1.684a.75.75 0 01-.372-.568 6.787 6.787 0 011.019-4.38z" clipRule="evenodd" />
      <path d="M5.082 14.254a8.287 8.287 0 00-1.308 5.135 9.687 9.687 0 01-1.764-.44l-.115-.04a.563.563 0 01-.373-.487l-.01-.121a3.75 3.75 0 013.57-4.047zM20.226 19.389a8.287 8.287 0 00-1.308-5.135 3.75 3.75 0 013.57 4.047l-.01.121a.563.563 0 01-.373.486l-.115.04c-.567.2-1.156.349-1.764.441z" />
    </svg>
  );

  const FAQIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
      <path fillRule="evenodd" d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zm11.378-3.917c-.89-.777-2.366-.777-3.255 0a.75.75 0 01-.988-1.129c1.454-1.272 3.776-1.272 5.23 0 1.513 1.324 1.513 3.518 0 4.842a3.75 3.75 0 01-.837.552c-.676.328-1.028.774-1.028 1.152v.75a.75.75 0 01-1.5 0v-.75c0-1.279 1.06-2.107 1.875-2.502.182-.088.351-.199.503-.331.83-.727.83-1.857 0-2.584zM12 18a.75.75 0 100-1.5.75.75 0 000 1.5z" clipRule="evenodd" />
    </svg>
  );

  const PlanIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
      <path d="M21.731 2.269a2.625 2.625 0 00-3.712 0l-1.157 1.157 3.712 3.712 1.157-1.157a2.625 2.625 0 000-3.712zM19.513 8.199l-3.712-3.712-8.4 8.4a5.25 5.25 0 00-1.32 2.214l-.8 2.685a.75.75 0 00.933.933l2.685-.8a5.25 5.25 0 002.214-1.32l8.4-8.4z" />
      <path d="M5.25 5.25a3 3 0 00-3 3v10.5a3 3 0 003 3h10.5a3 3 0 003-3V13.5a.75.75 0 00-1.5 0v5.25a1.5 1.5 0 01-1.5 1.5H5.25a1.5 1.5 0 01-1.5-1.5V8.25a1.5 1.5 0 011.5-1.5h5.25a.75.75 0 000-1.5H5.25z" />
    </svg>
  );

  const CategoryIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
      <path fillRule="evenodd" d="M5.25 2.25a3 3 0 00-3 3v4.318a3 3 0 00.879 2.121l9.58 9.581c.92.92 2.39 1.186 3.548.428a18.849 18.849 0 005.441-5.44c.758-1.16.492-2.629-.428-3.548l-9.58-9.581a3 3 0 00-2.122-.879H5.25zM6.375 7.5a1.125 1.125 0 100-2.25 1.125 1.125 0 000 2.25z" clipRule="evenodd" />
    </svg>
  );

  const ContactIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
      <path fillRule="evenodd" d="M1.5 4.5a3 3 0 013-3h1.372c.86 0 1.61.586 1.819 1.42l1.105 4.423a1.875 1.875 0 01-.694 1.955l-1.293.97c-.135.101-.164.249-.126.352a11.285 11.285 0 006.697 6.697c.103.038.25.009.352-.126l.97-1.293a1.875 1.875 0 011.955-.694l4.423 1.105c.834.209 1.42.959 1.42 1.82V19.5a3 3 0 01-3 3h-2.25C8.552 22.5 1.5 15.448 1.5 6.75V4.5z" clipRule="evenodd" />
    </svg>
  );

  const StudentIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
      <path d="M4.5 6.375a4.125 4.125 0 118.25 0 4.125 4.125 0 01-8.25 0zM14.25 8.625a3.375 3.375 0 116.75 0 3.375 3.375 0 01-6.75 0zM1.5 19.125a7.125 7.125 0 0114.25 0v.003l-.001.119a.75.75 0 01-.363.63 13.067 13.067 0 01-6.761 1.873c-2.472 0-4.786-.684-6.76-1.873a.75.75 0 01-.364-.63l-.001-.122zM17.25 19.128l-.001.144a2.25 2.25 0 01-.233.96 10.088 10.088 0 005.06-1.01.75.75 0 00.42-.643 4.875 4.875 0 00-6.957-4.611 8.586 8.586 0 011.71 5.157v.003z" />
    </svg>
  );

  const TestimonialIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
      <path fillRule="evenodd" d="M4.848 2.771A49.144 49.144 0 0112 2.25c2.43 0 4.817.178 7.152.52 1.978.292 3.348 2.024 3.348 3.97v6.02c0 1.946-1.37 3.678-3.348 3.97a48.901 48.901 0 01-3.476.383.39.39 0 00-.297.17l-2.755 4.133a.75.75 0 01-1.248 0l-2.755-4.133a.39.39 0 00-.297-.17 48.9 48.9 0 01-3.476-.384c-1.978-.29-3.348-2.024-3.348-3.97V6.741c0-1.946 1.37-3.68 3.348-3.97zM6.75 8.25a.75.75 0 01.75-.75h9a.75.75 0 010 1.5h-9a.75.75 0 01-.75-.75zm.75 2.25a.75.75 0 000 1.5H12a.75.75 0 000-1.5H7.5z" clipRule="evenodd" />
    </svg>
  );

  const SettingsIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
      <path fillRule="evenodd" d="M12 6.75a5.25 5.25 0 016.775-5.025.75.75 0 01.313 1.248l-3.32 3.319c.063.475.276.934.641 1.299.365.365.824.578 1.3.64l3.318-3.319a.75.75 0 011.248.313 5.25 5.25 0 01-5.472 6.756c-1.018-.086-1.87.1-2.309.634L7.344 21.3A3.298 3.298 0 112.7 16.657l8.684-7.151c.533-.44.72-1.291.634-2.309A5.342 5.342 0 0112 6.75zM4.117 19.125a.75.75 0 01.75-.75h.008a.75.75 0 01.75.75v.008a.75.75 0 01-.75.75h-.008a.75.75 0 01-.75-.75v-.008z" clipRule="evenodd" />
    </svg>
  );

  // قائمة القوائم - جميع الروابط محفوظة كما هي
  const menuItems = [
    { to: "/academy-admin", label: "الرئيسية", icon: <HomeIcon /> },
    { to: "/academy-admin/trainers/create", label: "المدرّبين", icon: <TrainerIcon /> },
    { to: "/academy-admin/faqs", label: "اضافه الاسئله الشائعه", icon: <FAQIcon /> },
    { to: "/academy-admin/plans", label: "الخطط", icon: <PlanIcon /> },
    { to: "/academy-admin/categories", label: "اضافه الفئات", icon: <CategoryIcon /> },
    { to: "/academy-admin/contacts", label: "روابط التواصل", icon: <ContactIcon /> },
    { to: "/academy-admin/students", label: "الطلاب", icon: <StudentIcon /> },
    { to: "/academy-admin/testimonials", label: "آراء المستخدمين", icon: <TestimonialIcon /> },
    { to: "/academy-admin/settings", label: "الإعدادات", icon: <SettingsIcon /> }
  ];

  // أنماط CSS
  const styles = {
    sidebar: {
      width: "280px",
      height: "100vh",
      backgroundColor: "#182848",
      position: "fixed",
      right: "0",
      top: "0",
      zIndex: "1000",
      boxShadow: "5px 0 15px rgba(0, 0, 0, 0.1)",
      overflowY: "auto",
      overflowX: "hidden",
      transition: "all 0.3s ease"
    },
    logoContainer: {
      padding: "25px 20px",
      borderBottom: "1px solid rgba(255, 255, 255, 0.1)",
      textAlign: "center",
      marginBottom: "10px"
    },
    logo: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: "12px",
      textDecoration: "none",
      color: "white"
    },
    logoIcon: {
      width: "40px",
      height: "40px",
      background: "linear-gradient(135deg, #4b6cb7 0%, #3a56a4 100%)",
      borderRadius: "10px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    },
    logoText: {
      display: "flex",
      flexDirection: "column",
      textAlign: "right"
    },
    logoTitle: {
      margin: "0",
      fontSize: "20px",
      fontWeight: "700",
      color: "white",
      lineHeight: "1.2"
    },
    logoSubtitle: {
      margin: "0",
      fontSize: "12px",
      color: "rgba(255, 255, 255, 0.7)",
      fontWeight: "500"
    },
    menuContainer: {
      padding: "20px 0"
    },
    menuList: {
      listStyle: "none",
      margin: "0",
      padding: "0"
    },
    menuItem: {
      marginBottom: "5px"
    },
    menuLink: {
      display: "flex",
      alignItems: "center",
      gap: "15px",
      padding: "15px 25px",
      textDecoration: "none",
      color: "rgba(255, 255, 255, 0.8)",
      fontSize: "15px",
      fontWeight: "500",
      transition: "all 0.3s ease",
      position: "relative",
      borderRight: "3px solid transparent"
    },
    menuLinkActive: {
      backgroundColor: "rgba(75, 108, 183, 0.2)",
      color: "white",
      borderRight: "3px solid #4b6cb7"
    },
    menuIcon: {
      width: "22px",
      height: "22px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexShrink: "0"
    },
    menuText: {
      flex: "1",
      textAlign: "right"
    },
    badge: {
      backgroundColor: "#4b6cb7",
      color: "white",
      fontSize: "11px",
      fontWeight: "600",
      padding: "3px 8px",
      borderRadius: "10px",
      marginRight: "10px"
    },
    newBadge: {
      backgroundColor: "#28a745",
      color: "white",
      fontSize: "10px",
      fontWeight: "600",
      padding: "2px 6px",
      borderRadius: "10px",
      position: "absolute",
      left: "20px",
      top: "50%",
      transform: "translateY(-50%)"
    },
    bottomSection: {
      padding: "20px",
      borderTop: "1px solid rgba(255, 255, 255, 0.1)",
      marginTop: "auto",
      position: "absolute",
      bottom: "0",
      width: "100%",
      backgroundColor: "#182848"
    },
    userInfo: {
      display: "flex",
      alignItems: "center",
      gap: "12px",
      marginBottom: "15px"
    },
    userAvatar: {
      width: "40px",
      height: "40px",
      borderRadius: "50%",
      backgroundColor: "#4b6cb7",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: "white",
      fontWeight: "600",
      fontSize: "16px"
    },
    userDetails: {
      flex: "1",
      textAlign: "right"
    },
    userName: {
      margin: "0",
      color: "white",
      fontSize: "14px",
      fontWeight: "600"
    },
    userRole: {
      margin: "0",
      color: "rgba(255, 255, 255, 0.7)",
      fontSize: "12px"
    },
    logoutButton: {
      width: "100%",
      padding: "10px",
      backgroundColor: "rgba(255, 255, 255, 0.1)",
      color: "rgba(255, 255, 255, 0.8)",
      border: "none",
      borderRadius: "8px",
      fontSize: "14px",
      fontWeight: "500",
      cursor: "pointer",
      transition: "all 0.3s",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: "8px"
    },
    copyright: {
      textAlign: "center",
      color: "rgba(255, 255, 255, 0.5)",
      fontSize: "11px",
      marginTop: "10px"
    }
  };

  return (
    <aside style={styles.sidebar}>
      {/* الشعار */}
      <div style={styles.logoContainer}>
        <a href="/academy-admin" style={styles.logo}>
          <div style={styles.logoIcon}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="white" style={{ width: "24px", height: "24px" }}>
              <path d="M11.7 2.805a.75.75 0 01.6 0A60.65 60.65 0 0122.83 8.72a.75.75 0 01-.231 1.337 49.949 49.949 0 00-9.902 3.912.75.75 0 01-.584 0A49.87 49.87 0 002 9.268a.75.75 0 01-.231-1.337A60.653 60.653 0 0111.7 2.805z" />
            </svg>
          </div>
          <div style={styles.logoText}>
            <h3 style={styles.logoTitle}>لوحة التحكم</h3>
            <p style={styles.logoSubtitle}>نظام الأكاديمية</p>
          </div>
        </a>
      </div>

      {/* قائمة التنقل */}
      <div style={styles.menuContainer}>
        <ul style={styles.menuList}>
          {menuItems.map((item, index) => (
            <li key={item.to} style={styles.menuItem}>
              <NavLink
                to={item.to}
                end={item.to === "/academy-admin"}
                style={({ isActive }) => ({
                  ...styles.menuLink,
                  ...(isActive ? styles.menuLinkActive : {})
                })}
                onMouseEnter={(e) => {
                  if (!e.currentTarget.classList.contains('active')) {
                    e.currentTarget.style.backgroundColor = "rgba(255, 255, 255, 0.1)";
                    e.currentTarget.style.color = "white";
                  }
                }}
                onMouseLeave={(e) => {
                  if (!e.currentTarget.classList.contains('active')) {
                    e.currentTarget.style.backgroundColor = "transparent";
                    e.currentTarget.style.color = "rgba(255, 255, 255, 0.8)";
                  }
                }}
              >
                <span style={styles.menuIcon}>{item.icon}</span>
                <span style={styles.menuText}>{item.label}</span>
                
                {/* إضافة شارة جديدة للعناصر الجديدة */}
                {item.label.includes("اضافه") && (
                  <span style={styles.newBadge}>جديد</span>
                )}
                
                {/* إضافة عدد للإشعارات إذا لزم الأمر */}
                {(item.label === "المدرّبين" || item.label === "الطلاب") && (
                  <span style={styles.badge}>5</span>
                )}
              </NavLink>
            </li>
          ))}
        </ul>
      </div>

      {/* قسم المستخدم في الأسفل */}
      <div style={styles.bottomSection}>
        <div style={styles.userInfo}>
          <div style={styles.userAvatar}>م</div>
          <div style={styles.userDetails}>
            <p style={styles.userName}>مدير النظام</p>
            <p style={styles.userRole}>Administrator</p>
          </div>
        </div>
        
        <button 
          style={styles.logoutButton}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = "rgba(220, 53, 69, 0.3)";
            e.currentTarget.style.color = "white";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = "rgba(255, 255, 255, 0.1)";
            e.currentTarget.style.color = "rgba(255, 255, 255, 0.8)";
          }}
          onClick={() => {
            // يمكن إضافة منطق تسجيل الخروج هنا
            localStorage.removeItem('academy_token');
            window.location.href = '/academy-login';
          }}
        >
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" style={{ width: "16px", height: "16px" }}>
            <path fillRule="evenodd" d="M7.5 3.75A1.5 1.5 0 006 5.25v13.5a1.5 1.5 0 001.5 1.5h6a1.5 1.5 0 001.5-1.5V15a.75.75 0 011.5 0v3.75a3 3 0 01-3 3h-6a3 3 0 01-3-3V5.25a3 3 0 013-3h6a3 3 0 013 3V9a.75.75 0 01-1.5 0V5.25a1.5 1.5 0 00-1.5-1.5h-6zm10.72 4.72a.75.75 0 011.06 0l3 3a.75.75 0 010 1.06l-3 3a.75.75 0 11-1.06-1.06l1.72-1.72H9a.75.75 0 010-1.5h10.94l-1.72-1.72a.75.75 0 010-1.06z" clipRule="evenodd" />
          </svg>
          تسجيل الخروج
        </button>
        
        <p style={styles.copyright}>© 2024 نظام الأكاديمية v1.0</p>
      </div>

      {/* إضافة تنسيقات CSS إضافية */}
      <style>{`
        ::-webkit-scrollbar {
          width: 6px;
        }
        
        ::-webkit-scrollbar-track {
          background: rgba(255, 255, 255, 0.05);
        }
        
        ::-webkit-scrollbar-thumb {
          background: rgba(255, 255, 255, 0.2);
          border-radius: 3px;
        }
        
        ::-webkit-scrollbar-thumb:hover {
          background: rgba(255, 255, 255, 0.3);
        }
        
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateX(-10px);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }
        
        .menu-item {
          animation: fadeIn 0.3s ease-out;
          animation-fill-mode: both;
        }
        
        .menu-item:nth-child(1) { animation-delay: 0.1s; }
        .menu-item:nth-child(2) { animation-delay: 0.15s; }
        .menu-item:nth-child(3) { animation-delay: 0.2s; }
        .menu-item:nth-child(4) { animation-delay: 0.25s; }
        .menu-item:nth-child(5) { animation-delay: 0.3s; }
        .menu-item:nth-child(6) { animation-delay: 0.35s; }
        .menu-item:nth-child(7) { animation-delay: 0.4s; }
        .menu-item:nth-child(8) { animation-delay: 0.45s; }
        .menu-item:nth-child(9) { animation-delay: 0.5s; }
        
        @media (max-width: 768px) {
          .sidebar {
            width: 70px;
          }
          
          .logo-text, .menu-text, .user-details, .logout-button span, .copyright {
            display: none;
          }
          
          .logo {
            justify-content: center;
          }
          
          .logo-icon {
            width: 35px;
            height: 35px;
          }
          
          .menu-link {
            padding: 15px;
            justify-content: center;
          }
          
          .new-badge, .badge {
            display: none;
          }
          
          .user-info {
            justify-content: center;
          }
          
          .logout-button {
            padding: 10px;
          }
        }
      `}</style>
    </aside>
  );
}